export default {
  Actionslist() {
    return [
      {
        title: "Data",
        icon: "database",
        value: "data",
        description: "",
        fields: [
          { title: "Item toevoegen", value: "add-row", icon: "plus" },
          { title: "Item bewerken", value: "edit-row", icon: "pencil" },
          { title: "Item verwijderen", value: "delete-row", icon: "trash-2" },
          {
            title: "Kopieer naar klembord",
            value: "copy-clipboard",
            icon: "copy"
          },
          {
            title: "Toon notificatie",
            value: "show-message",
            icon: "message-square-quote"
          }
        ]
      },
      {
        title: "Interaction",
        icon: "mouse-pointer-click",
        value: "interaction",
        description: "",
        fields: [
          {
            title: "Toon detail scherm",
            value: "go-to-detail-screen",
            icon: "monitor-up"
          },
          {
            title: "Toon bewerk scherm",
            value: "go-to-edit-screen",
            icon: "pencil"
          },
          {
            title: "Toon form scherm",
            value: "show-form-screen",
            icon: "panel-right-open"
          },
          {
            title: "Verberg form scherm",
            value: "hide-form-screen",
            icon: "panel-right-close"
          },

          // { title: "Verberg detail scherm", value: "hide-detail-screen" }
          { title: "Mijn profiel", value: "go-to-profile", icon: "user" },
          { title: "Open pagina", value: "go-to-page", icon: "link" },
          { title: "Open URL", value: "open-url", icon: "link-2" },
          { title: "Ga terug", value: "go-back", icon: "undo-2" }
        ]
      },
      {
        title: "Communication",
        icon: "send",
        value: "communication",
        description: "",
        fields: [
          {
            title: "E-mail opstellen",
            value: "compose-email",
            icon: "mail-plus"
          },
          { title: "E-mail versturen", value: "send-mail", icon: "send" },
          {
            title: "Telefoonnummer bellen",
            value: "dial-phone-number",
            icon: "phone-call"
          },
          { title: "Deel link", value: "share-link", icon: "share" }
        ]
      }
    ];
  }
};
